import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// Until each section is built, all menu routes render the Coming Soon page
const comingSoon = () => import('../views/coming-soon/coming-soon.vue')

const routes = [
  {
    path: '/',
    name: 'home',
    component: comingSoon,
    meta: { title: 'Turn10 Racing' }
  },
  {
    path: '/about',
    name: 'about',
    component: comingSoon,
    meta: { title: 'About Us' }
  },
  {
    path: '/driver-training',
    name: 'driver-training',
    component: comingSoon,
    meta: { title: 'Driver Training' }
  },
  {
    path: '/wrl-2026',
    name: 'wrl-2026',
    component: comingSoon,
    meta: { title: 'WRL 2026' }
  },
  {
    path: '/gallery',
    name: 'gallery',
    component: comingSoon,
    meta: { title: 'Gallery' }
  },
  {
    path: '/contact',
    name: 'contact',
    component: comingSoon,
    meta: { title: 'Contact Us' }
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
